<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import type { ClassValue } from "svelte/elements";
	import Icon from "./common/Icon.svelte";

	const {
		title,
		description,
		icon,
		class: customClass,
	}: { class?: ClassValue; title: string; description: string; icon?: string } = $props();
</script>

<div
	class={[
		customClass,
		"bg-white/50 backdrop-blur-xl grid md:grid-cols-2 gap-y-3 gap-x-16 md:gap-y-4 sm:grid-cols-2 rounded-3xl pb-10 px-6 pt-6 lg:!p-6",
	]}
>
	<h3 class="text-cmcsecondary uppercase font-druk-cond text-2xl md:text-5xl/[0.9] flex gap-2">
		{#if icon}
			<span class="md:hidden">
				<Icon {icon} class="size-6 text-cmcprimary" />
			</span>
		{/if}
		<Formatted text={title} />
	</h3>
	<p class="text-xs/[1.5] md:text-base font-medium xl:h-24 line-clamp-5">
		<Formatted text={description} />
	</p>
</div>
